import PropTypes from 'prop-types';
import CloseBtn from '../../../common/CloseBtn';
import React from 'react';
import { Modal, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { viewModalStyles } from '../../styles';

const ReattemptPaymentModal = ({ classes, data, onClose, onConfirm, loading }) => {
    return (
        <Modal open={!!data} onClose={onClose} className={classes.modal}>
            <div className={classes.root} style={{ width: 470 }}>
                <div className={classes.closeBtn}>
                    <CloseBtn onClick={onClose} />
                </div>
                <div className={classes.header}>
                    <p style={{ textAlign: 'center', fontSize: 16, fontWeight: 500 }}>Reattempt failed DD Payment</p>
                </div>
                <div style={{ textAlign: 'center', fontSize: 14, padding: '0 24px' }}>
                    <p>
                        Check with your client before proceeding to ensure that they have enough funds in their account
                        to make this payment.
                    </p>
                    <p>If there is another failed payment due to lack of funds, you will be charged up to &pound;10.</p>
                    <p>If you are not sure, please do not continue.</p>
                </div>
                <div className={classes.actions} style={{ width: '100%', margin: '20px auto' }}>
                    <Button className={classes.cancelButton} key="cancel" variant="outlined" onClick={onClose}>
                        Back
                    </Button>
                    <Button disabled={loading} className={classes.confirmButton} onClick={onConfirm}>
                        Continue
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

ReattemptPaymentModal.propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default withStyles(viewModalStyles)(ReattemptPaymentModal);
